// Mark — the site's own little accent icon, used wherever a small "highlight"
// glyph is needed (eyebrows, kickers, CTAs). It deliberately replaces the
// ubiquitous lucide "Sparkles" star so the guide reads as hand-made, not
// template. A bold, slightly-tilted editorial asterisk / compass burst drawn
// in currentColor, so any `text-*` class still controls its colour. The API
// mirrors a lucide icon (size / className / strokeWidth) for drop-in use.
export const Mark = ({ size = 16, className = "", strokeWidth = 2.25, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
    {...props}
  >
    {/* six-spoke asterisk, tilted ~8° for a hand-set, print feel */}
    <g transform="rotate(8 12 12)">
      <path d="M12 2.5v19" />
      <path d="M3.77 7.25 20.23 16.75" />
      <path d="M20.23 7.25 3.77 16.75" />
    </g>
    {/* a tiny satellite dot — the signature flourish */}
    <circle cx="19.4" cy="4.6" r="1.15" fill="currentColor" stroke="none" />
  </svg>
);

export default Mark;
